// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.ruleset-dialog {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px 24px;
  max-height: 80vh;
  box-sizing: border-box;
}

.ruleset-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
}

.cross-icon {
  color: var(--primary);
  opacity: 0.5;
  cursor: pointer;
  padding: 6.5px;
  height: 20px;
  width: 20px;
  font-size: 20px;
  position: relative;
  top: -2px;
}

.cross-icon:hover {
  opacity: 1;
}

.ruleset-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #2f2f2f;
}

.ruleset-subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #7a7a7a;
  text-transform: uppercase;
}

.ruleset-summary {
  padding: 16px 18px;
  border: 1px solid #ececec;
  border-radius: 10px;
  background: #fafafa;
}

.summary-label {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary);
  text-transform: uppercase;
}

.summary-text {
  margin: 0;
  color: #5d5d5d;
  line-height: 1.5;
}

.ruleset-body {
  overflow: auto;
  padding-bottom: 12px;
}

.rules-accordion {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mat-mdc-expansion-panel {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: none;
  margin-bottom: 12px;
}

.mat-mdc-expansion-panel-header {
  padding: 0 16px;
}

.rule-title {
  font-weight: 600;
  color: #3d3d3d;
}

.rule-content {
  padding: 0 16px 18px;
}

.rule-description {
  margin: 0;
  color: #636363;
  line-height: 1.5;
}

.mat-mdc-expansion-panel-header:hover {
  background: #f9fafb;
}`, "",{"version":3,"sources":["webpack://./src/app/auto-cx/components/fdd-ruleset-view/fdd-ruleset-view.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.ruleset-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px 24px;\n  max-height: 80vh;\n  box-sizing: border-box;\n}\n\n.ruleset-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.close-button {\n  border: none;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n}\n\n.cross-icon {\n  color: var(--primary);\n  opacity: .5;\n  cursor: pointer;\n  padding: 6.5px;\n  height: 20px;\n  width: 20px;\n  font-size: 20px;\n  position: relative;\n  top: -2px;\n}\n\n.cross-icon:hover {\n  opacity: 1;\n}\n\n.ruleset-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #2f2f2f;\n}\n\n.ruleset-subtitle {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #7a7a7a;\n  text-transform: uppercase;\n}\n\n.ruleset-summary {\n  padding: 16px 18px;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  background: #fafafa;\n}\n\n.summary-label {\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--primary);\n  text-transform: uppercase;\n}\n\n.summary-text {\n  margin: 0;\n  color: #5d5d5d;\n  line-height: 1.5;\n}\n\n.ruleset-body {\n  overflow: auto;\n  padding-bottom: 12px;\n}\n\n.rules-accordion {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.mat-mdc-expansion-panel {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  box-shadow: none;\n  margin-bottom: 12px;\n}\n\n.mat-mdc-expansion-panel-header {\n  padding: 0 16px;\n}\n\n.rule-title {\n  font-weight: 600;\n  color: #3d3d3d;\n}\n\n.rule-content {\n  padding: 0 16px 18px;\n}\n\n.rule-description {\n  margin: 0;\n  color: #636363;\n  line-height: 1.5;\n}\n\n.mat-mdc-expansion-panel-header:hover {\n  background: #f9fafb;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
